
import { overrideStore, parametrize } from 'react-overridable';

import { ResultsListItemWithState } from '@components_common/components/items/GlobalSearchResultListItem.jsx';


overrideStore.add('External_datasets.Search.ResultsList.item', ResultsListItemWithState);
